import React from "react";
import { Spinner } from "react-bootstrap";

interface LoadingDisplayProps {
  loading: boolean;
}

function LoadingDisplay({ loading }: LoadingDisplayProps) {
  return loading ? (
    <div className="center-page">
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  ) : (
    <></>
  );
}

export default LoadingDisplay;
